export const DATE_FORMAT = 'YYYY-MM-DD HH:MM:SS';
export const TRIAL_DURATION = 14; // days
